export default {"src":"/_next/static/media/vector_3.e851a09e.svg","height":126,"width":297,"blurWidth":0,"blurHeight":0};